import { useOrganization } from "@/api/services/admin/organization";
import { ItemInfo } from "@/components/commons/ItemInfo";
import { InnerBox } from "@/modules/irohana-components/elements/InnerBox";
import { Grid } from "@mui/material";

export const OrganizationOtherInfo = () => {
  const { data } = useOrganization();
  const org = data?.data;

  return (
    <InnerBox title="その他情報（顧客未開示の情報）" p={3} bordered>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ItemInfo label="備考" value={org?.note} type="textArea" isShowDivider={false} />
        </Grid>
      </Grid>
    </InnerBox>
  );
};
